import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import {responsiveStoreEnhancer} from 'redux-responsive'
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';

import calendarViewV2Reducer from '../reducers/calendarViewV2Reducer';
import eventFormReducer from '../../EventForm/reducers/eventFormReducer';

const rootReducer = combineReducers({
  calendarView: calendarViewV2Reducer,
  eventForm: eventFormReducer
});

const configureStore = (railsProps) => (
  createStore(rootReducer, railsProps, compose(
    applyMiddleware(createDebounce(), thunk),
    responsiveStoreEnhancer
  ))
);

export default configureStore;
